import { createFileRoute } from '@tanstack/react-router'

import { SalesScorecardScreen } from './-components/scorecard-screen.tsx'

export const Route = createFileRoute('/sales/scorecard')({
  component: SalesScorecardScreen
})
